import { AlertStatus } from "../types/machine-alert";

/**
 * Tailwind classes for an alert verdict, so every surface that shows a status
 * agrees on what it looks like.
 *
 * Before this, the ml-exports event panel carried an inline ternary that only
 * distinguished Resolved from "everything else" — which quietly painted
 * Ignored the same amber as Pending, making a dismissed alert look like one
 * still waiting on an operator. Ignored gets its own muted treatment here:
 * it is a closed verdict, not an open one.
 *
 * Colours come from the same palette the alert queue uses.
 */
export const ALERT_STATUS_STYLE: Record<AlertStatus, string> = {
  [AlertStatus.Pending]: "bg-amber-500/10 text-amber-500 border-amber-500/20",
  [AlertStatus.Resolved]: "bg-emerald-500/10 text-emerald-500 border-emerald-500/20",
  [AlertStatus.Ignored]: "bg-muted text-muted-foreground border-border",
};

/**
 * Style for a status that may have come off the wire as an unrecognised
 * string. Falls back to Pending's treatment — an unknown verdict is safer
 * shown as "needs attention" than as resolved.
 */
export const alertStatusStyle = (status: string | null | undefined): string =>
  ALERT_STATUS_STYLE[status as AlertStatus] ?? ALERT_STATUS_STYLE[AlertStatus.Pending];
